import Scrollbar from 'smooth-scrollbar'
import Choreographer from 'choreographer-js'
import Preload from 'preload-js'
import Promise from 'promise-polyfill'
import Swiper from 'swiper'

import HomeData from '../home-data'
import PreloadManifest from '../preload-manifest'

if (!window.Promise) {
  window.Promise = Promise;
}

export default {
  name: 'home',
  methods: {
    getTrans() {
      return document.documentElement.clientWidth <= 416 // 26em = 416px
        ? [
          { propertyName: 'opacity', className: 'Loader' },
          { propertyName: 'transform', className: 'Loader' },
        ]
        : [
          { propertyName: 'height', className: 'Landing' },
          { propertyName: 'transform', className: 'Loader' },
        ]
    },
    raceTransitions(transitions) {
      let transPrms = []

      transitions.forEach(el => {
        transPrms.push(this.waitTransitionEnd(el.propertyName, el.className))
      })
      return Promise.race(transPrms)
    },
    waitTransitionEnd(propertyName, className) {
      return new Promise(resolve => {
        const el = document.querySelector(`.${className}`)
        const transitionendRef =
          el.addEventListener(window.transitionEnd, event => {
            if (event.propertyName.indexOf(propertyName) >= 0 && event.target.className == className) {
              el.removeEventListener(window.transitionEnd, transitionendRef, false)
              resolve()
            }
          }, false)

          setTimeout(() => {
            el.removeEventListener(window.transitionEnd, transitionendRef, false)
            resolve()
          }, 4000)
      })
    },

    // Events
    jumpTo(event) {
      let el

      // if (event.target.hash == '#app') {
      //   el = document.querySelector('#projects')
      // } else {
        el = document.querySelector(`${event.target.hash} h1`)
      // }

      this.scrollbar.scrollIntoView(el, { offsetTop: 32 })
      this.menuIsOpen = false
    },

    // Init
    initScrollbar() {
      this.scrollbar = Scrollbar.init(this.$el.querySelector('.Home-content'), { syncCallbacks: true })
      this.scrollbar.addListener(status => { if (typeof this.choreographer !== 'undefined') this.choreographer.runAnimationsAt(status.offset.y) })

      return Promise.resolve()
    },
    initChoreographer() {
      const view = this.scrollbar.getSize()
      const offsetTop = el => (el.getBoundingClientRect().top + document.body.scrollTop)

      const animations =
        Array.prototype.slice.call(this.$el.querySelectorAll('[data-aos]'))
          .map(el => ({
            selector: el,
            range: [offsetTop(el) + (el.offsetHeight * 2 / 3) - view.container.height, view.content.height],
            type: 'change',
            style: 'class',
            to: 'aos-animate',
          }))

          // Add landing animation
          .concat([
            {
              selector: this.$el.querySelector('.Landing-bg'),
              range: [0, view.container.height],
              type: 'scale',
              style: 'opacity',
              from: 1,
              to: 0,
            },
            {
              selector: document.querySelectorAll('.Logo'),
              range: [0, view.container.height / 3],
              type: 'syncMainVue',
              style: 'updatedata',
              unit: 'minLogo',
              from: false,
              to: true,
            },
          ])

      this.choreographer = new Choreographer({
        customFunctions: {
          syncMainVue: data => {
            if (data.progress < 1 && this[data.unit] == data.to) {
              let appClasses = {}

              this[data.unit] = data.from
              appClasses[data.unit] = data.from
              this.$emit(data.style, { key: 'appClasses', value: appClasses })
            } else if (data.progress >= 1 && this[data.unit] == data.from) {
              let appClasses = {}

              this[data.unit] = data.to
              appClasses[data.unit] = data.to
              this.$emit(data.style, { key: 'appClasses', value: appClasses })
            }
          },
        },
        animations
      })

      return Promise.resolve()
    },
    initSwiper() {
      new Swiper ('.swiper-container', {
        loop: true,
        pagination: '.swiper-pagination',
        autoplay: 6000,
        autoHeight: true,
      })
    },
    initPreload() {
      return new Promise(resolve => {
        const queue = new Preload.LoadQueue(false)

        queue.on('complete', resolve, this)
        queue.loadManifest(PreloadManifest.home)
        queue.load()
      })
    },
  },
  mounted() {
    const beforePreload = new Date()

    this
      .initPreload()
      .then(() => new Promise(resolve => { // Wait 4000ms if necessary
        const elapsed = new Date() - beforePreload

        this.isPreloaded = true
        setTimeout(resolve, elapsed <= 4000 ? 4000 - elapsed : 0)
      }))
      .then(() => { // Start transition
        this.$emit('updatestate', 2)
        return this.raceTransitions(this.getTrans())
      })
      .then(() => { // Init scroll and choreographer now that height is fixed
        this.initScrollbar()
        this.initChoreographer()
        this.initSwiper()
        this.$emit('updatedata', { key: 'appClasses', value: { whiteLogo: false } })
        this.$emit('updatestate', 0)
      })
  },
  activated() {
    if (this.isPreloaded) { // This is not the first activation
      setTimeout(() => { this.$emit('updatestate', 2) }, 1200)
      this
        .raceTransitions(this.getTrans())
        .then(() => { // Init scroll and choreographer now that height is fixed
          this.$emit('updatedata', { key: 'appClasses', value: { whiteLogo: false } })
          this.$emit('updatestate', 0)
        })
    }
  },
  data() {
    return Object.assign(HomeData, {
      minLogo: false,
      menuIsOpen: false,
      isPreloaded: false,
    })
  },
  head: {
    title: {
      inner: 'Fany Righi',
      separator: '—',
      complement: 'UI Design - Webdesign - Graphisme'
    },
    meta: [
      { name: 'description', content: 'Designer freelance basée à Nantes', id: 'meta-description' },
      { name: 'og:title', content: 'Fany Righi — UI Design - Webdesign - Graphisme', id: 'og-title' },
      { name: 'og:description', content: 'Designer freelance basée à Nantes', id: 'og-description' },
      { name: 'og:url', content: 'http://fanyrighi.com/', id: 'og-url' },
      { name: 'twitter:title', content: 'Fany Righi — UI Design - Webdesign - Graphisme', id: 'twitter-title' },
      { name: 'twitter:description', content: 'Designer freelance basée à Nantes', id: 'twitter-description' },
      { name: 'twitter:url', content: 'http://fanyrighi.com/', id: 'twitter-url' },
    ],
    link: [
      { rel: 'canonical', href: 'http://fanyrighi.com/', id: 'meta-canonical' },
    ],
  },
}



// WEBPACK FOOTER //
// ./src/components/Home.js